import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { AuthService } from '../../auth/auth.service';
import { Role } from '../../models/role';

const endpoint = environment.apiBaseUrl + '/admin/chat';
const httpOptions = {
  headers: new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/octet-stream'
  }),
};

@Injectable({
  providedIn: 'root'
})
export class AsistenteChatService {

  constructor(private httpClient: HttpClient, private authService: AuthService) { }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  esAdministrador() {
    for (let role of this.authService.getUser().roles) {
      if (role == Role.Admin || role == Role.MenuAdministrator) {
        return true;
      }
    }
    return false;
  }

  add(codigoAsistente, descripcion, nombre, gafuAreaFuncional, idDestinatario, encoladoMaximo, 
    guardarHistorico, tema, requiereAutenticacion, requiereEncuesta,codigoEncuesta) {

    const params = {
      codigoAsistente: codigoAsistente,
      descripcion: descripcion,
      nombre: nombre,
      gafuAreaFuncional: gafuAreaFuncional,
      userName: this.authService.getUser().username,
      habilitado: true,
      requiereAutenticacion: requiereAutenticacion,
      chat: {
        idDestinatario: parseInt(idDestinatario as string, 10),
        encoladoMaximo: parseInt(encoladoMaximo as string, 10),
        guardarHistorico: guardarHistorico,
        tema: tema,
        requiereEncuesta:requiereEncuesta,
        codigoEncuesta:codigoEncuesta
      }
    }

    return this.httpClient.post(`${endpoint}/add`, params)
  }

  update(idAsistente, codigoAsistente, descripcion, nombre, gafuAreaFuncional, habilitado, requiereAutenticacion, idDestinatario, encoladoMaximo, 
    guardarHistorico, tema, requiereEncuesta,codigoEncuesta) {

    const params = {
      idAsistente: idAsistente,
      codigoAsistente: codigoAsistente,
      descripcion: descripcion,
      nombre: nombre,
      gafuAreaFuncional: gafuAreaFuncional,
      habilitado: habilitado,
      userName: this.authService.getUser().username,
      requiereAutenticacion: requiereAutenticacion,
      chat: {
        idDestinatario: parseInt(idDestinatario as string, 10),
        encoladoMaximo: parseInt(encoladoMaximo as string, 10),
        guardarHistorico: guardarHistorico,
        tema: tema,
        requiereEncuesta:requiereEncuesta,
        codigoEncuesta:codigoEncuesta
      }
    }

    return this.httpClient.post(`${endpoint}/update`, params)
  }

  get(id) {
    return this.httpClient.get(`${endpoint}/display/${id}`)
  }

  delete(id, updateUser) {
    const params = {
      id
    }
    return this.httpClient.post(`${endpoint}/delete/${id}/${updateUser}`, params);
  }

}
